import { Skeleton, Typography } from '@atgfr8/atg-ui-tailwind';
import { CHANGE_TRACKING_SOURCES } from '@changeTracking/utils/changeTrackingRegistry';
import { FeedbackTrigger } from '@components/FeedbackTrigger/FeedbackTrigger';
import { orderStore } from '@store/orders';
import { ConfigManager } from '@utils/ConfigManager';
import { Show } from 'solid-js';

import { HeaderControl } from './HeaderControl';
import HeaderInfo from './HeaderInfo';

export function OrderPageHeader() {
  return (
    <Show
      when={!orderStore.loading}
      fallback={
        <div class="flex justify-start bg-white sticky shadow-lg py-4 pl-2">
          <Skeleton variant="rectangular" height={20} width={200} />
        </div>
      }
    >
      <div class="flex justify-between items-center min-h-12 bg-white sticky shadow-lg h-fit ">
        <Show when={ConfigManager.showLayout}>
          <Typography
            variant="subtitle2"
            class="text-[20px]! whitespace-nowrap pl-2"
          >
            {orderStore.isCreate
              ? 'New Order'
              : orderStore.order.id === 0
                ? 'Order'
                : `Order #${orderStore.order.id}`}
          </Typography>
          <FeedbackTrigger
            variant="static"
            source={
              CHANGE_TRACKING_SOURCES.orderDetails.orderDetailsPageFeedback
            }
            class="ml-1 shrink-0"
          />
        </Show>
        <div class="flex flex-col flex-1 flex-wrap flex-row justify-between items-center gap-2 overflow-hidden py-2">
          <HeaderControl />
          <HeaderInfo />
        </div>
      </div>
    </Show>
  );
}
